import { render, staticRenderFns } from "./NewSlugInput.vue?vue&type=template&id=0a489705&"
import script from "./NewSlugInput.vue?vue&type=script&lang=js&"
export * from "./NewSlugInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports